import React from 'react';
import { restrictUrls } from '../../../../helpers/adminPrivileges';
import PurchasePlansHistory from './PurchasePlansHistory';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import messages from '../../../../locale/jsonMessages';

export default async function action({ store, intl, params }) {

    const title = intl?.formatMessage(messages.servicePlanLabel);

    const userId = params?.id

    // From Redux Store
    let isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
    const adminPrivileges = store?.getState()?.account?.privileges && store?.getState()?.account?.privileges?.privileges;
    const privileges = store?.getState()?.listSettings && store?.getState()?.listSettings?.privileges;
    const isServicePlanEnabled = store?.getState()?.siteSettings?.data?.isServicePlanEnabled

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (isServicePlanEnabled == 'false') {
        return { redirect: '/siteadmin' };
    }

    if (!restrictUrls('/siteadmin/user-purchased-plans', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }
    return {
        title,
        component: (
            <AdminLayout>
                <PurchasePlansHistory userId={userId} />
            </AdminLayout>
        ),
    };
}
